import _regeneratorRuntime from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue";
var _hoisted_1 = {
  class: "navbar"
};
var _hoisted_2 = {
  class: "right-menu"
};
var _hoisted_3 = {
  class: "avatar-wrapper"
};
var _hoisted_4 = ["src"];
var _hoisted_5 = {
  style: {
    "font-size": "12px"
  }
};
import Breadcrumb from './Breadcrumb.vue';
import Hamburger from './Hamburger.vue';
import ErrorLog from './ErrorLog.vue';
import Screenfull from './ScreenFull.vue';
import Refresh from './Refresh.vue';
import Notification from './Notification.vue';
import useStore from '@/store';

import { useRouter } from 'vue-router';
import { computed } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'Navbar',
  setup: function setup(__props) {
    var store = useStore();
    var router = useRouter();
    var profile = computed(function () {
      return store.user.profile;
    });
    var device = computed(function () {
      return store.app.device;
    });
    var sidebar = computed(function () {
      return store.app.sidebar;
    });
    function toggleSideBar() {
      store.app.toggleSideBar();
    }
    function logout() {
      return _logout.apply(this, arguments);
    }
    function _logout() {
      _logout = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return store.user.logout();
            case 2:
              window.location.reload();
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _logout.apply(this, arguments);
    }
    return function (_ctx, _cache) {
      var _component_el_avatar = _resolveComponent("el-avatar");
      var _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      var _component_router_link = _resolveComponent("router-link");
      var _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      var _component_el_dropdown = _resolveComponent("el-dropdown");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(Hamburger, {
        id: "hamburger-container",
        "is-active": _unref(sidebar).opened,
        class: "hamburger-container",
        onToggleClick: toggleSideBar
      }, null, 8, ["is-active"]), _createVNode(Breadcrumb, {
        id: "breadcrumb-container",
        class: "breadcrumb-container"
      }), _createElementVNode("div", _hoisted_2, [_unref(device) !== 'mobile' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createVNode(Refresh, {
        id: "refresh",
        class: "right-menu-item hover-effect"
      }), _createVNode(ErrorLog, {
        class: "errLog-container right-menu-item hover-effect"
      }), _createVNode(Screenfull, {
        id: "screenfull",
        class: "right-menu-item hover-effect"
      }), _createVNode(Notification, {
        class: "right-menu-item hover-effect"
      })], 64)) : _createCommentVNode("", true), _createVNode(_component_el_dropdown, {
        class: "avatar-container right-menu-item hover-effect",
        trigger: "click"
      }, {
        dropdown: _withCtx(function () {
          return [_createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(function () {
              return [_createVNode(_component_router_link, {
                to: "/"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_dropdown_item, null, {
                    default: _withCtx(function () {
                      return _cache[0] || (_cache[0] = [_createTextVNode("主页")]);
                    }),
                    _: 1
                  })];
                }),
                _: 1
              }), _createVNode(_component_router_link, {
                to: "/profile"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_dropdown_item, null, {
                    default: _withCtx(function () {
                      return _cache[1] || (_cache[1] = [_createTextVNode("个人信息")]);
                    }),
                    _: 1
                  })];
                }),
                _: 1
              }), _createVNode(_component_el_dropdown_item, {
                divided: "",
                onClick: logout
              }, {
                default: _withCtx(function () {
                  return _cache[2] || (_cache[2] = [_createElementVNode("span", {
                    style: {
                      "display": "block"
                    }
                  }, "退出登录", -1)]);
                }),
                _: 1
              })];
            }),
            _: 1
          })];
        }),
        default: _withCtx(function () {
          var _unref2, _unref3;
          return [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_avatar, {
            size: 26,
            src: (_unref2 = _unref(profile)) === null || _unref2 === void 0 ? void 0 : _unref2.avatarCode,
            class: "user-avatar"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("img", {
                src: require('@/assets/images/avatars/male.png')
              }, null, 8, _hoisted_4)];
            }),
            _: 1
          }, 8, ["src"]), _createElementVNode("span", _hoisted_5, _toDisplayString((_unref3 = _unref(profile)) === null || _unref3 === void 0 ? void 0 : _unref3.nickname), 1)])];
        }),
        _: 1
      })])]);
    };
  }
});